import api from './api'

export type SendGiftCardEmailParams = {
  amount: number
  recipientEmail: string
  recipientName?: string
  cardNumber: string
  senderName?: string
  message?: string
}

export async function sendGiftCardEmail(params: SendGiftCardEmailParams): Promise<void> {
  await api.post('/gift-cards/send', {
    amount: String(params.amount),
    recipient_email: params.recipientEmail.trim(),
    recipient_name: params.recipientName?.trim() || null,
    card_number: params.cardNumber.trim(),
    sender_name: params.senderName?.trim() || null,
    message: params.message?.trim() || null,
  })
}
